import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { useMediaQuery } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import { useTheme } from '@mui/material/styles';

import SideNavComponent from './SideNavComponent';

import { setDrawerOpen } from '../Main/actions';

import * as commonSelectors from '../Shared/selectors';

import usePrevious from '../../hooks/usePrevious';

const SideNavContainer = (props) => {
  const { isDrawerOpen, isMobileScreen, setDrawerOpen } = props;

  const theme = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down('md'));
  const prevScreenSize = usePrevious(isSmScreen);

  useEffect(() => {
    if (prevScreenSize !== undefined) {
      setDrawerOpen(!isSmScreen);
    }
  }, [isSmScreen]);

  if (isMobileScreen) {
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.appBar + 1 }}
        open={isDrawerOpen}
        onClick={() => setDrawerOpen(false)}
        style={{ justifyContent: 'flex-start' }}
      >
        <SideNavComponent {...props} />
      </Backdrop>
    );
  }
  return <SideNavComponent {...props} />;
};

SideNavContainer.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  isMobileScreen: PropTypes.bool.isRequired,
  setDrawerOpen: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {
    common: { isNavigationShown, isDrawerOpen },
  } = state;
  return {
    isNavigationShown,
    isDrawerOpen,
    isMobileScreen: commonSelectors.getIsMobileScreen(state),
    navLogoUrl: commonSelectors.getLogoUrl(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setDrawerOpen: (isDrawerOpen) => setDrawerOpen(dispatch, isDrawerOpen),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNavContainer);
